import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";
import { getCustomFields } from "../../services/ExportedPatientCustomField";
import apiClient from "../../services/Http";

const notiMessage = new NotiMessage("success");

//URL List
const eachDataUrl = "patient/getEach?";
const allDataUrl = "patient/get?";
const exportedDataUrl = "patient/export?";
const storeUrl = "patient/store";
const updateUrl = "patient/update";
const deleteUrl = "patient/delete";

const getDefaultState = () => {
  return {
    patient: {},
    isPreEnroll: false,
  };
};

const state = {
  patients: [],
  exported_patients: [],
  patient: {},
  isPreEnroll: false,
  pageCount: 1,
  totalPatients: 0,
  complementarySupports: [],
  complementarySupportTypes: [],
};
const getters = {
  dotsPatientHandler(state) {
    var patient = state.patient;
    return {
      id: patient.id ? patient.id : "",
      name: patient.name ? patient.name : "",
      dob: patient.dob ? patient.dob : "",
      age: patient.age ? patient.age : "",
      address: patient.address ? patient.address : "",
      phone: "",
      sex: patient.sex ? patient.sex : "",
      volunteer: "",
      weight: "",
      tb_code: patient.mdrtb_reg_no ? patient.mdrtb_reg_no : "",
      tb_year: patient.mdrtb_reg_year ? patient.mdrtb_reg_year : "",
      type_of_tb: patient.type_of_tb ? patient.type_of_tb : "",
      mdrtb_regiment: patient.mdrtb_regiments ? patient.mdrtb_regiments[0].mdrtb_regiment_id : "",
      treatment_startdate: patient.treatment_startdate
        ? patient.treatment_startdate
        : "",
      dots_startdate: patient.dots_patient.dots_startdate,
      dots_enddate: patient.dots_patient.dots_enddate,
    };
  },
  exportedPatientHandler(state) {
    var patients = [];
    if (state.exported_patients.length > 0) {
      var mostEnrollCount = 0;
      state.exported_patients.map((val) => {
        if (val.enroll_supports.length > mostEnrollCount)
          mostEnrollCount = val.enroll_supports.length;
      });

      state.exported_patients.map((element) => {
        patients.push(getCustomFields(element, mostEnrollCount));
      });
    }
    return patients;
  },
};
const mutations = {
  SET_PRE_ENROLL_YES(state) {
    state.isPreEnroll = true;
  },
  SET_PATIENTS(state, payload) {
    state.patients = payload;
  },
  SET_EXPORTED_PATIENTS(state, payload) {
    state.exported_patients = payload.data.data;
  },
  SET_PATIENT(state, payload) {
    state.patient = payload.data.data;
  },
  SET_PATIENT_PAGE(state, payload) {
    state.pageCount = payload;
  },
  SET_TOTAL_PATIENTS(state, payload) {
    state.totalPatients = payload;
  },
  ADD_PATIENT(state, payload) {
    state.patients.push(payload.data.data);
  },
  REMOVE_PATIENT(state, payload) {
    const patients = state.patients.filter((item) => item.id != payload.id);
    state.patients = [...patients];
  },
  SET_COMPLEMENTARY_SUPPORTS(state, payload) {
    state.complementarySupports = payload;
  },
  SET_COMPLEMENTARY_SUPPORT_TYPES(state, payload) {
    state.complementarySupportTypes = payload;
  },
  REMOVE_COMPLEMENTARY_SUPPORT(state, supportId) {
    state.complementarySupports = state.complementarySupports.filter(support => support.id !== supportId);
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async getPatients({ commit }, params) {
    const response = await Request.get_data(allDataUrl, params);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("SET_PATIENTS", response.data.data.result);
      commit("SET_PATIENT_PAGE", response.data.data.page);
      // Store total if available in response
      if (response.data.data.total !== undefined) {
        commit("SET_TOTAL_PATIENTS", response.data.data.total);
      }
      return true;
    }
    return false;
  },
  async getReportedPatient(commit, params) {
    const response = await Request.get_data(exportedDataUrl, params);
      let maxEnrollCount = 0;
      if (response.data.data.length > 0) {
       response.data.data.map((val) => {
          if (val.enroll_supports.length > maxEnrollCount)
          maxEnrollCount = val.enroll_supports.length;
        });
        // console.log(response.data.data.map((v) => {
        //   // console.log(getCustomFields(v, maxEnrollCount));
        //  return getCustomFields(v, maxEnrollCount)
        // }));
       return response.data.data.map((val) => getCustomFields(val, maxEnrollCount));
      }
    return false;
  },

  async exportPatient(context, payload) {
    let url = `https://api.mdr.tbtheunion.com/api/dashboard/patient/export?`;
    if (payload) {
      Object.keys(payload).forEach((key) => {
        url += `&${key}=${payload[key]}`;
      });
    }
    await apiClient
      .get(url, {
        responseType: "blob",
      })
      .then(() => {
        window.location = url;
      });
  },

  async complementaryPatient(context, payload) {
    const url = `https://api.mdr.tbtheunion.com/api/dashboard/complementary-patient/store`;
  
    const response = await apiClient.post(url, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  
    return response.data;
  },

  async getComplementarySupports({ commit }, patientId) {
    const url = `https://api.mdr.tbtheunion.com/api/dashboard/complementary-patient/get?patient_id=${patientId}`;
    
    const response = await apiClient.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (response.data && response.data.data) {
      commit("SET_COMPLEMENTARY_SUPPORTS", response.data.data);
    }
    
    return response.data;
  },

  async getComplementarySupportTypes({ commit }) {
    const url = `https://api.mdr.tbtheunion.com/api/complementary-support-types/get`;
    
    const response = await apiClient.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (response.data && response.data.data) {
      commit("SET_COMPLEMENTARY_SUPPORT_TYPES", response.data.data);
    }
    
    return response.data;
  },

  async deleteComplementarySupport({ commit }, supportId) {
    const url = `https://api.mdr.tbtheunion.com/api/dashboard/complementary-patient/delete/${supportId}`;
    
    const response = await apiClient.delete(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (response.data && response.data.success) {
      commit("REMOVE_COMPLEMENTARY_SUPPORT", supportId);
    }
    
    return response.data;
  },

  async getPatientsByVolunteer({ commit }, payload) {
    const response = await Request.get_data(allDataUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PATIENTS", response.data.data.result);
    commit("SET_PATIENT_PAGE", response.data.data.page);
  },
  async searchPatientsByTownship({ commit }, payload) {
    const response = await Request.get_data(allDataUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PATIENTS", response.data.data.result);
    commit("SET_PATIENT_PAGE", response.data.data.page);
  },
  async searchPatientsByName({ commit }, payload) {
    const response = await Request.get_data(allDataUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PATIENTS", response.data.data.result);
    commit("SET_PATIENT_PAGE", response.data.data.page);
  },
  async searchPatientsByCode({ commit }, payload) {
    const response = await Request.get_data(allDataUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PATIENTS", response.data.data.result);
    commit("SET_PATIENT_PAGE", response.data.data.page);
  },
  async searchPatientBySupport({ commit }, payload) {
    const response = await Request.get_data(allDataUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PATIENTS", response.data.data.result);
    commit("SET_PATIENT_PAGE", response.data.data.page);
  },
  async searchPatientByOnging({ commit }, payload) {
    const response = await Request.get_data(allDataUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PATIENTS", response.data.data.result);
    commit("SET_PATIENT_PAGE", response.data.data.page);
  },
  async searchPatientsByNominated({ commit }, payload) {
    const response = await Request.get_data(allDataUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PATIENTS", response.data.data.result);
    commit("SET_PATIENT_PAGE", response.data.data.page);
  },
  async getPatient({ commit }, id) {
    commit("resetState");
    const response = await Request.get_data(eachDataUrl, {
      column: "id",
      value: id,
    });
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("SET_PATIENT", response);
      if (response.data.data.pre_enroll == 1)
        commit("SET_PRE_ENROLL_YES", response);
      return true;
    }
    return false;
  },
  async getEnrollExport(context, payload) {
    let url = `https://api.mdr.tbtheunion.com/api/patient-enroll/export?`;
    if (payload) {
        Object.keys(payload).forEach((key) => {
            url += `&${key}=${payload[key]}`;
        });
    }
    await apiClient
        .get(
            url, {
                responseType: "blob",
            }
        )
        .then(() => {
            window.location = url;
        });
  },
  
  async getComplementaryExport(context, payload) {
    let url = `https://api.mdr.tbtheunion.com/api/complementary-patient/export?`;
    if (payload) {
        Object.keys(payload).forEach((key) => {
            url += `&${key}=${payload[key]}`;
        });
    }
    await apiClient
        .get(
            url, {
                responseType: "blob",
            }
        )
        .then(() => {
            window.location = url;
        });
  },
  

  async createPatient({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_PATIENT", response);
      notiMessage.displayNotiMsg("Saved Success");
      return true;
    }
    return false;
  },
  async updatePatient(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg("Updated Success");
      return true;
    }
    return false;
  },
  async deletePatient({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_PATIENT", payload);
      notiMessage.displayNotiMsg("Deleted Success");
      return true;
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
